import qs from "qs";
import Endpoint from "@/utils/endPoint";

const loginEndpoint = new Endpoint("/login/access-token");
const loginWithCodeEndpoint = new Endpoint("/login/verification_code");
const registerEndpoint = new Endpoint("/users/mobile");
const registerWithPassEndpoint = new Endpoint("/users/password");
const userInfoEndpoint = new Endpoint("/users/me");
const verifyCodeEndpoint = new Endpoint("/messages/verification_codes/{mobile}");
const matchedTeacherUserEndpoint = new Endpoint("/users/teachers/matched");

class UserService {
    async loginService(params) {
        let postJson = { ...params, scope: process.env.VUE_APP_SCOPE }
        postJson = qs.stringify(postJson)
        const result = await loginEndpoint.post(postJson);
        return result;
    }
    async loginWithCodeService(params) {
        let postJson = { ...params, scope: process.env.VUE_APP_SCOPE }
        postJson = qs.stringify(postJson)
        const result = await loginWithCodeEndpoint.post(postJson);
        return result;
    }
    async registerService(params) {
        const result = await registerEndpoint.postWithParams(params, { scopes: process.env.VUE_APP_SCOPE });
        return result;
    }
    async registerWithPassService(params) {
        let postJson = { ...params, scopes: process.env.VUE_APP_SCOPE }
        postJson = qs.stringify(postJson)
        const result = await registerWithPassEndpoint.postWithParams(postJson, { scopes: process.env.VUE_APP_SCOPE });
        return result;
    }
    async getUserInfoService(params) {
        const result = await userInfoEndpoint.get(params);
        return result;
    }
    async updateUserInfoService(params) {
        const result = await userInfoEndpoint.put(params);
        return result;
    }
    async getVerifyCodeService(params) {
        const result = await verifyCodeEndpoint.post(null, params);
        return result;
    }

    async getMatchedTeacherUserService(params) {
        const result = await matchedTeacherUserEndpoint.get(params);
        return result;
    }
}

export default new UserService();
